import Reveal from 'components/ui/Reveal';
import SectionHeading from 'components/ui/SectionHeading';
import { NUTRITION_DATA } from 'lib/constants';

export default function NutritionSection() {
  // Fallback if NUTRITION_DATA is not populated in constants
  const nutritionData = NUTRITION_DATA || [
    { label: 'Energy', value: '567 kcal' },
    { label: 'Protein', value: '25.8 g' },
    { label: 'Total Fat', value: '49.2 g' },
    { label: 'Carbohydrates', value: '16.1 g' },
    { label: 'Dietary Fiber', value: '8.5 g' },
    { label: 'Sodium', value: '18 mg' },
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-singaraa-ivory">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20">
        <Reveal>
          <SectionHeading
            eyebrow="NUTRITION"
            title="Approximate Nutritional Values"
            subtitle="Wholesome nourishment and natural energy in every bite"
            className="mb-8 sm:mb-12 md:mb-14"
          />
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6">
          {nutritionData.map((item, index) => (
            <Reveal key={index} delay={index * 0.05}>
              <div className="bg-white p-3.5 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl shadow-sm border border-singaraa-brown/5 flex flex-col items-center justify-center text-center h-full hover:border-singaraa-caramel/30 transition-colors">
                <span className="font-heading text-xs sm:text-sm md:text-base text-singaraa-dark/70 mb-1 sm:mb-2">
                  {item.label}
                </span>
                <span className="font-heading text-lg sm:text-xl md:text-2xl text-singaraa-brown font-bold">
                  {item.value}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <p className="text-center font-body text-xs sm:text-sm text-singaraa-dark/60 mt-6 sm:mt-10 max-w-2xl mx-auto px-2">
            * Values are approximate and per serving. Refer to product packaging for exact values.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
